"use client";

import { c as _c } from "react/compiler-runtime";
import { useMediaQuery } from "@/hooks/use-media-query";
import { MapProvider } from "@/providers/map";
import { StepAddress as StepAddressDesktop } from "./step-2-address-desktop";
import { StepAddress as StepAddressMobile } from "./step-2-address-mobile";
interface AddressFormData {
  projectName: string;
  location: {
    locality: string;
    address: string;
    city: string;
    pin: string;
    coordinates: {
      lat: number;
      lng: number;
    };
  };
}
interface StepAddressProps {
  onNext: (data: AddressFormData) => void;
  onBack?: () => void;
  isLoading?: boolean;
}
export function StepAddress(t0) {
  const $ = _c(5);
  const {
    onNext,
    onBack,
    isLoading
  } = t0;
  const isMobileView = useMediaQuery("(max-width: 768px)");
  let t1;
  if ($[0] !== isLoading || $[1] !== isMobileView || $[2] !== onBack || $[3] !== onNext) {
    t1 = <MapProvider>{isMobileView ? <StepAddressMobile onNext={onNext} onBack={onBack} isLoading={isLoading} /> : <StepAddressDesktop onNext={onNext} onBack={onBack} isLoading={isLoading} />}</MapProvider>;
    $[0] = isLoading;
    $[1] = isMobileView;
    $[2] = onBack;
    $[3] = onNext;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}